export const checkEmail = (value) => {
  return /^(?!.*(?:''|\.\.))([a-zA-Z0-9_\-\+\.]*[a-zA-Z0-9_\-])@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/.test(value);

};
